import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { TranslateModule } from '@ngx-translate/core';
import { NgPipesModule } from 'ngx-pipes';

import { AtMentionModule } from '@app/core/_common/at-mention/at-mention.module';
import { SharedModule } from '@app/shared/shared.module';

import { CommentFormComponent } from './comment-form/comment-form.component';
import { CommentsComponent } from './comments/comments.component';
import { CommentsListComponent } from './comments-list/comments-list.component';
import { MessagingRoutingModule } from './messaging-routing.module';

@NgModule({
  declarations: [CommentFormComponent, CommentsComponent, CommentsListComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    TranslateModule,
    NgPipesModule,
    MatPaginatorModule,
    MessagingRoutingModule,
    AtMentionModule,
  ],
  exports: [CommentsComponent],
})
export class MessagingModule {}
